import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { USAePayService } from 'src/app/services/usaepay.service';
import { USAePay, USAePayPayload } from "src/app/models/USAePay";

@Component({
    selector: 'mwp-member-payment-information',
    templateUrl: "./payment-information.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PaymentInformationComponent implements OnInit {
    public apiUrl = ContentHeaderKey.PaymentInformation;
    public uSAePay: USAePay;

    constructor(
        private uSAePayService: USAePayService,
    ) {
    }

    ngOnInit(): void {
        this.uSAePayService.getUSAePay().subscribe((response: USAePay) => {
            this.uSAePay = response;
        });
    }

    public save(payload: USAePayPayload): void {
        this.uSAePayService.updateUSAePay(payload).subscribe((response: USAePay) => {
            this.uSAePay = response;
        });
    }
}
